import "@hotwired/turbo-rails"
import "../../controllers"
import "../../controllers/auth"
import { initializeAxeptio } from "../../lib/axeptio"

initializeAxeptio()
